import React from 'react';
import ExecutiveSummary from './ExecutiveSummary';
import QuestionRenderer from './QuestionRenderer';
import { SurveyResults, LegacyTableData } from './types';

interface ProfessionalSurveyResultsProps {
  data: SurveyResults | { tables: LegacyTableData[] };
  contentType?: string;
  isExporting?: boolean;
  className?: string;
  images?: string[];
  onImageClick?: (src: string, alt: string) => void;
}

const ProfessionalSurveyResults: React.FC<ProfessionalSurveyResultsProps> = ({ 
  data, 
  contentType, 
  isExporting = false,
  className = '',
  images = [],
  onImageClick
}) => {
  // Check if this is the new enhanced survey format
  const isEnhancedFormat = 'survey_results' in data;
  
  if (!isEnhancedFormat) {
    // Fallback to legacy table rendering for backward compatibility
    const legacyData = data as { tables: LegacyTableData[] };
    return (
      <div className={`space-y-6 ${className}`}>
        {legacyData.tables?.map((table, index) => (
          <div key={index} className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">{table.title || `Table ${index + 1}`}</h3>
            <div className="text-gray-600 text-sm">Legacy table format</div>
          </div>
        ))}
      </div>
    );
  }

  const surveyData = data as SurveyResults;

  return (
    <div className={`space-y-8 ${className}`}>
      {/* Executive AI Summary - Temporarily commented out */}
      {/* {surveyData.summary.ai_summary && (
        <ExecutiveSummary aiSummary={surveyData.summary.ai_summary} />
      )} */}

      {/* Survey Overview - Temporarily commented out */}
      {/* <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">Survey Overview</h2>
        <div className="flex items-center space-x-8 text-sm text-gray-600">
          <div>
            <span className="font-medium text-gray-900">{surveyData.survey_results.total_questions}</span>
            <span className="ml-1">Questions</span>
          </div>
          <div>
            <span className="font-medium text-gray-900">{surveyData.survey_results.total_respondents}</span>
            <span className="ml-1">Respondents</span>
          </div>
        </div>
      </div> */}

      {/* Question by Question Results */}
      <div className="space-y-6">
        {/* <h2 className="text-xl font-semibold text-gray-900">Question Analysis</h2> */}
        {surveyData.survey_results.questions.map((question, index) => (
          <div 
            key={question.question_id || index}
            className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm"
          >
            <QuestionRenderer 
              question={question}
              index={index}
              isExporting={isExporting}
              images={images}
              onImageClick={onImageClick}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfessionalSurveyResults;